import { Tabs } from "@shared/ui/tabs";
import { AlertCircle, AlertTriangle } from "lucide-react";
import React from "react";
import {
  useConsumerListMissingPlan,
  useConsumerListMissingTariff,
  usePlansList,
} from "../../hooks";
import { MissingPlansContent } from "./MissingPlansContent";
import { MissingTariffsContent } from "./MissingTarifs";
import { PlansListContent } from "./PlansListContent";

interface PlansTariffsTabProps {
  billCycleId: number; // or string if that's the correct type
  billDraftId:string;
}

export const PlansTariffsTab: React.FC<PlansTariffsTabProps> = ({
  billCycleId,
  billDraftId
}) => {
  const { data: consumerListMissingTariff } = useConsumerListMissingTariff(
    billCycleId,
  billDraftId,
    1
  );
  console.log("consumerListMissingTariff in PlansTariffsTab",consumerListMissingTariff)
  const { data: consumerListMissingPlan } = useConsumerListMissingPlan(
    billCycleId,
    billDraftId,
    1
  );
  const missingDataTabsConfig = {
    "missing-plans": {
      label: "Missing Plan Details",
      icon: <AlertCircle className="h-4 w-4" />,
      count: consumerListMissingPlan?.count,
      component: <MissingPlansContent billDraftId={billDraftId} data={consumerListMissingPlan} />,
    },
    "missing-tariffs": {
      label: "Missing Tariff Details",
      icon: <AlertTriangle className="h-4 w-4" />,
      count: consumerListMissingTariff?.count,
      component: <MissingTariffsContent billDraftId={billDraftId} data={consumerListMissingTariff}/>,
    },
  };
  const { data: planList } = usePlansList();

  // Plans List Tabs Configuration
  const plansTabsConfig = {
    plans: {
      label: "Plans",
      component: <PlansListContent />,
      count: planList?.count,
    },
  };

  return (
    <div className="space-y-4 py-4">
      <div className="bg-card rounded-lg border">
        <div className="p-6 pb-0">
          <h3 className="text-lg font-semibold">Missing Data</h3>
          <p className="text-sm text-muted-foreground">
            Incomplete consumer and plan data that requires attention
          </p>
        </div>
        <div className="p-6 pt-4">
          <Tabs
            defaultValue="missing-plans"
            tabComponents={missingDataTabsConfig}
            tabsListClassName="w-full grid grid-cols-2"
            idPrefix="missing-data"
            disableUrlSync={true}
          />
        </div>
      </div>

      {/* Plans Section with Nested Tabs */}
      <Tabs
        defaultValue="plans"
        tabComponents={plansTabsConfig}
        idPrefix="plans-list"
        className="w-full grid grid-cols-1"
        tabsListFullWidth={true}
        urlMapping={{
          "missing-plans": "missing-plans",
          "missing-tariffs": "missing-tariffs",
        }}
        level={2}
      />
    </div>
  );
};
